import { jsx as _jsx } from "react/jsx-runtime";
import moment from 'moment';
import { PromoPreview } from './promo-preview';
import { useEditableField } from '../../../hooks/use-editable-field';
import { useSession } from '../../../../../../infra/session';
import { renderPromoCodeValue } from '../../../../components/promo-code-select/helpers';
import { t } from '../../../../../../infra/i18n';
export var PromoPreviewContainer = function (_a) {
    var _b, _c;
    var promo = _a.promo;
    var dateFormat = useEditableField('dateFormat').field;
    var session = useSession().data;
    var sessionView = session.view;
    var currency = (_b = sessionView.meta) === null || _b === void 0 ? void 0 : _b.currency;
    var promoCodeValue = renderPromoCodeValue(promo, currency);
    var code = promo.code;
    var appliesTo = promo.rules.find(function (item) { return item.kind === 5; })
        ? t('engage:campaign_builder.review.new_clients')
        : t('engage:campaign_builder.review.everyone');
    var expirationDate = (_c = promo.rules.find(function (item) { return item.kind === 2; })) === null || _c === void 0 ? void 0 : _c.endDate;
    var expiration = expirationDate
        ? moment(expirationDate).format(dateFormat.value)
        : t('engage:campaign_builder.review.no_expiry');
    var codeUsage = promo.rules.find(function (item) { return item.kind === 6; })
        ? t('engage:campaign_builder.review.one_time')
        : t('engage:campaign_builder.review.unlimited');
    return (_jsx(PromoPreview, { value: promoCodeValue, code: code, expiration: expiration, appliesTo: appliesTo, codeUsage: codeUsage }));
};
